/**
 * 路由名 -> sys_permission.id 的映射 (烘干厂端)
 *
 * T-017 起: 单一来源从 menuStructure.js 派生, 避免 ROUTE_PERM_MAP / MENU_ORDER
 * 与菜单结构脱节.
 *
 * 用于:
 *   1) MainLayout.vue   按 store.permKeys 过滤左侧菜单
 *   2) router/index.js  beforeEach 守卫拦截未授权页面
 *   3) store/index.js   firstAccessibleRoute getter 决定登录后跳到哪个页面
 *
 * 非业务路由 (notice / profile) 不在此映射, 默认全员可见.
 */
import { ALL_ITEMS, PUBLIC_ROUTES as _PUBLIC_ROUTES } from '@/config/menuStructure'

// 路由 name -> 后端权限 id
export const ROUTE_PERM_MAP = ALL_ITEMS.reduce((acc, it) => {
  if (it.perm) acc[it.key] = it.perm
  return acc
}, {})

// 全员可见的路由 (不受 permKeys 限制)
export const PUBLIC_ROUTES = _PUBLIC_ROUTES

// MainLayout 主菜单顺序 (登录跳转时按这个顺序找第一个有权的)
// superOnly 项不参与: 它只能做 SUPPER_ADMIN 的落点候选, 而超管必然还有 entry-v1 等更靠前的菜单;
// 排除后可避免"只被授予 superOnly 权限的用户"登录落点与 requireSuperAdmin 守卫互相重定向成环
export const MENU_ORDER = ALL_ITEMS.filter(it => !it.superOnly).map(it => it.key)
